'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/context/redeem/context.tsx
import { createContext } from "react";
var defaultState = {
  coupon: {
    discount: 0,
    ticket_ids: [],
    promo_code: ""
  },
  saudi_redeem: null,
  saudi_redeem_total: 0,
  enable_wallet_credits: false,
  qitaf: null
};
var context_default = createContext(__spreadProps(__spreadValues({}, defaultState), {
  setCoupon: () => {
  },
  setSaudiRedeem: () => {
  },
  setRedeemType: () => {
  },
  setSelectedTicketIds: () => {
  },
  setQitaf: () => {
  }
}));

export {
  defaultState,
  context_default
};
//# sourceMappingURL=chunk-BEC3XFLK.mjs.map